<template>
    <div v-if="freeTextEnabled">
        <p class="body-semibold">In your own words</p>
        <p class="body-small text-ink-muted mt-1">Describe how you like to work, communicate, and make decisions.</p>
        <VoiceTextarea
            v-model:input="freeText"
            class="mt-2"
            :rows="5"
            :maxlength="MAX_FREE_TEXT_LENGTH"
            placeholder="Type or dictate anything that reflects how you work"
            textarea-aria-label="Describe how you work"
            textarea-class="body-small" />
        <output class="block text-right details text-ink-muted" aria-label="Character count"> {{ formatNumber(freeText.length) }}/{{ formatNumber(MAX_FREE_TEXT_LENGTH) }} </output>
    </div>
</template>

<script setup lang="ts">
import VoiceTextarea from "~vue/components/form/VoiceTextarea.vue";
import { formatNumber } from "~vue/utils/formatNumber";

const MAX_FREE_TEXT_LENGTH = 50000;

type FreeTextUploadProps = {
    freeTextEnabled: boolean;
};

defineProps<FreeTextUploadProps>();

const freeText = defineModel<string>("freeText", { required: true });
</script>

<style scoped></style>
